import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Controller } from 'src/app/interfaces/controller';
import { QueryCheck } from 'src/app/interfaces/queryCheck';
import { URL } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ControllerModalService {
  readonly http = inject(HttpClient);

  /*****************************************************************************👌
   * Add a controller.                                                          *
   * @param applicationId The ID of the application to add the controller to    *
   * @param controller The controler to add.                                    *
   * @returns An Observable of void                                             *
   ******************************************************************************/
  addController(applicationId: number, controller: Controller): Observable<void> {
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(controller);
    return this.http.put<void>(`${URL.url}${URL.applications}/${applicationId}/controller`, body, { headers });
  }

  /***************************************************************************👌
   * Update a controller.                                                     *
   * @param controllerId The ID of the controller to update.                  *
   * @param controller the updated controller.                                *
   * @returns An Observable of void.                                          *
   ***************************************************************************/
  updateController(controllerId: number, controller: Controller): Observable<void> {
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(controller);
    return this.http.put<void>(`${URL.url}${URL.controllers}${controllerId}`, body, { headers });
  }

  /******************************************************************************************************************👌
   * This function checks if the query that we add for the controller is correct before updating the controller.     *
   * @param {QueryCheck} query - The query to check.                                                                 *
   * @returns {Observable<string>} - The result of the check.                                                           *
   *******************************************************************************************************************/
  checkQuery(query: QueryCheck): Observable<string> {
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(query);
    return this.http.put<string>(`${URL.url}${URL.controllers}checkQuery`, body, { headers });
  }
}
